import { IComponentOptions } from 'angular';

export const TooltipWarningComponent: IComponentOptions = {
  bindings: {
    messages: '<',
    mainText: '<',
  },
  template: require('./tooltip-warning.html'),
};
